/*
 * Copyright (c) Worldline 2023.
 */

/**
 * End user web services
 * Endpoints of end user web services
 *
 * The version of the OpenAPI document: 2.2.3-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * This Dto gives information about a document.
 */
export interface DocumentDto { 
    /**
     * Document Name set in the init.
     */
    documentName?: string;
    /**
     * Number of existing signature on the Document.
     */
    signatureNumber?: number;
    /**
     * External Identifier of the Document.
     */
    extDocumentId?: string;
    /**
     * External Status of the Document.
     */
    externalDocumentStatus?: DocumentDto.ExternalDocumentStatusEnum;
}
export namespace DocumentDto {
    export type ExternalDocumentStatusEnum = 'SIGNATURES_REMAINING' | 'SIGNATURE_IN_PROGRESS' | 'SIGNED' | 'DATA_TO_UPLOAD';
    export const ExternalDocumentStatusEnum = {
        SignaturesRemaining: 'SIGNATURES_REMAINING' as ExternalDocumentStatusEnum,
        SignatureInProgress: 'SIGNATURE_IN_PROGRESS' as ExternalDocumentStatusEnum,
        Signed: 'SIGNED' as ExternalDocumentStatusEnum,
        DataToUpload: 'DATA_TO_UPLOAD' as ExternalDocumentStatusEnum
    };
}


